import { render } from "./qeval.vue?vue&type=template&id=64f86d5a"
import script from "./qeval.vue?vue&type=script&lang=js"
export * from "./qeval.vue?vue&type=script&lang=js"

import "./qeval.vue?vue&type=style&index=0&id=64f86d5a&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__